
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.133 8.201l5.02-5.02a.668.668 0 01.524-.194l3.512.27c.328.026.59.287.615.616l.27 3.511a.669.669 0 01-.194.524l-5.02 5.02a.668.668 0 01-.946 0L3.133 9.147a.669.669 0 010-.946zm11.274-.92a2.006 2.006 0 01-.581 1.573l-5.02 5.02a2.006 2.006 0 01-2.837 0l-3.782-3.782a2.006 2.006 0 010-2.836l5.02-5.02a2.006 2.006 0 011.573-.582l3.511.27c.986.076 1.77.86 1.846 1.846l.27 3.512z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M9.751 4.893a1.003 1.003 0 101.418 1.418 1.003 1.003 0 00-1.418-1.418z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.024 9.146l1.89 1.891a.668.668 0 10.946-.945L5.97 8.2a.669.669 0 10-.946.945z","fill":"currentColor"}})])
          )
        }
      }
    